import React from 'react';
import { checklistDateLabel, monthChecklist } from '../shared/monthBundle';
import { plainTaskTitle } from '../shared/homeFacts';

function itemTitle(task) {
  return plainTaskTitle(task.task_name || (task.task && task.task.title) || 'Task');
}

export default function MonthChecklist({ tasks, colors, brandColor = '#59c4c4' }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const list = monthChecklist(tasks, today);
  return (
    <section
      data-testid="month-checklist"
      aria-label={list.title}
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: '1rem',
        padding: '1rem',
        marginBottom: '1rem',
      }}
    >
      <div style={{ fontSize: '0.8rem', letterSpacing: '0.04em', textTransform: 'uppercase', color: colors.textSecondary }}>
        {checklistDateLabel(list.date)}
      </div>
      <h2 style={{ margin: '0.2rem 0 0.75rem', color: colors.text, fontSize: '1.25rem' }}>{list.title}</h2>
      {list.items.length === 0 ? (
        <p style={{ margin: 0, color: colors.textSecondary }}>Nothing due this month.</p>
      ) : (
        <ol style={{ margin: 0, paddingLeft: '1.2rem', color: colors.text }}>
          {list.items.slice(0, 8).map((task) => (
            <li key={task.id || itemTitle(task)} style={{ margin: '0.35rem 0', lineHeight: 1.35 }}>
              <span style={{ fontWeight: 650 }}>{itemTitle(task)}</span>
            </li>
          ))}
        </ol>
      )}
      <p style={{ margin: '0.75rem 0 0', color: brandColor, fontWeight: 650, fontSize: '0.9rem' }}>
        One Saturday. Up to 8 items.
      </p>
    </section>
  );
}
